import { render, staticRenderFns } from "./WorkerStaffInfo.vue?vue&type=template&id=098c0a25&scoped=true&"
import script from "./WorkerStaffInfo.vue?vue&type=script&lang=js&"
export * from "./WorkerStaffInfo.vue?vue&type=script&lang=js&"
import style0 from "./WorkerStaffInfo.vue?vue&type=style&index=0&id=098c0a25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098c0a25",
  null
  
)

export default component.exports